import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {Building, BuildingData} from "../../types/Building";
import deserializeBuilding from "./deserializers/building";
import {parameters} from "../string";

type BuildingFilters = {
    zone?: number | null
    sort?: string | null
    page?: number
    perPage?: number
}

/**
 * Get all buildings (paginated)
 */
const filtered = async (filters: BuildingFilters = {}) => {
    const params = parameters(filters, {page: 1, per_page: 100});

    try {
        const page = (await client.get<DataResource<Building> | null>('/buildings', {params})).data

        if (page) page.data = page.data.map(deserializeBuilding)

        return page
    } catch (error) {
        console.error("Unable to fetch buildings", error)
        return null
    }
}

/**
 * Get a single building
 *
 * @param {number} buildingId
 */
const get = async (buildingId: number) => {
    try {
        const building = (await client.get<Building | null>(`/buildings/${buildingId}`)).data
        return building ? deserializeBuilding(building) : null
    } catch (error) {
        console.error(`Unable to fetch building ${buildingId}`, error)
        return null
    }
}

/**
 * Store a new building
 *
 * @param data
 */
const store = async (data: BuildingData) => {
    try {
        const building = (await client.post<Building | null>('/buildings', data)).data
        return building ? deserializeBuilding(building) : null
    } catch (error) {
        console.error("Unable to store building", error)
        throw error
    }
}

/**
 * Update an existing building
 *
 * @param {number} buildingId
 * @param data
 */
const update = async (buildingId: number, data: BuildingData) => {
    try {
        const building = (await client.put<Building | null>(`/buildings/${buildingId}`, data)).data
        return building ? deserializeBuilding(building) : null
    } catch (error) {
        console.error(`Unable to update building ${buildingId}`, error)
        throw error
    }
}

/**
 * Permanently delete a building
 *
 * @param {number} buildingId
 */
const destroy = async (buildingId: number) => {
    try {
        return (await client.delete<null>(`/buildings/${buildingId}`)).status === 204
    } catch (error) {
        console.error(`Unable to delete building ${buildingId}`, error)
        throw error
    }
}

const buildings = {
    filtered,
    get,
    store,
    update,
    destroy
}

export default buildings;